import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { StorageService } from '../../../services/storage.service';
import { ApiService } from '../../../services/api.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit {

  constructor(private storageService: StorageService, private apiService: ApiService, private router: Router) { }  

  formLogin!: FormGroup

  ngOnInit(): void {

    this.formLogin = new FormGroup({
      username: new FormControl(null, Validators.required),
      password: new FormControl(null, [Validators.required, Validators.minLength(5)])
    })

    const user = this.storageService.getUser();
    const token = this.storageService.getToken();
    if (user?.id && token) {
      this.apiService.isAuthorized().subscribe({
        next: (res) => {
          if (res === true || (res && typeof res === 'object' && res.result === true)) {
            this.router.navigate(['/backoffice']);
          } else {
            this.storageService.clearStorage();
          }
        },
        error: () => this.storageService.clearStorage(),
      });
    }
  }

  onLogin() {

    this.apiService.login(this.formLogin.get('username')?.value, this.formLogin.get('password')?.value).subscribe({
      next: (res) => {
        this.storageService.setUser({ user: res.user, email: res.email, tipo: res.tipo, id: res.id })
        this.storageService.setToken(res.accessToken);
      },
      error: (err) => {
        if (err.status == 403) {
          this.apiService.message('error', 'Errore', err.error.message.message)
        } else {
          this.apiService.message('error', 'Errore', "Credenziali errate!")
        }
      },
      complete: () => this.router.navigate(['/backoffice'])
    });

  }

}
